const cardRoundedShadow = {
  boxShadow: '0px 5px 17px rgba(48, 85, 107, 0.2)',
  borderRadius: '20px',
};

export { cardRoundedShadow };
